import { useState, useContext, useEffect, useRef, useCallback } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser, CommaFire } from "../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../context";
import { PurchaseHistoryApi, PurchaseHistoryExportApi } from "../../api";
import { toPng } from 'html-to-image';

export const PurchaseHistory = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [tableData, setTableData] = useState<any>([])
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [jsonParms, setJsonParms] = useState({ 'page': 1 })
    const [visible, setVisible] = useState<boolean>(false)
    const [selectedFile, setSelected] = useState<any>(null)
    const ref = useRef<HTMLDivElement>(null)

    const exportFactor = useCallback(() => {
        if (ref.current === null) {
            return
        }
        toPng(ref.current, { cacheBust: true, })
            .then((dataUrl) => {
                const link = document.createElement('a')
                link.download = 'purchase-history.png'
                link.href = dataUrl
                link.click()
                setVisible(false)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [ref])


    const changePage = (type: string) => {
        let data = { ...jsonParms };
        if (type == 'next') {
            data['page'] = currentPage + 1;
        }
        else {
            data['page'] = currentPage - 1;
        }
        setJsonParms(data)
        getData(data)
    }

    const openFactor = async (item: any) => {
        console.log(item);

        setSelected(item)
        setVisible(true)
    }

    const getData = async (params: any) => {
        try {
            CtxLoad.setDisplayLoadingBlur(true)
            let res = await PurchaseHistoryApi(params)
            CtxLoad.setDisplayLoadingBlur(false)
            setTableData(res.data.data)
            setCurrentPage(res.data.current_page)
            setLastPage(res.data.last_page)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingBlur(false)
        }
    }

    useEffect(() => {
        document.title = "تاریخچه خرید | دایان"
        CtxNav.setActiveMenuItem({ 'item': 6, 'subItem': 0, })
        getData(jsonParms)

    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">تاریخچه خرید</h1>

            <div className=" w-full flex flex-col">
                {tableData.map((item: any, index: number) =>
                    <div key={index} className=" w-full p-5 bg-white shadow rounded-lg mb-2 flex sm:flex-row flex-col items-center">
                        <div className="w-[calc(100%-60px)] flex-col ">
                            <span className="text-[11px] mb-1">{new Date(item.created_at).toLocaleDateString('fa-Ir')}</span>
                            <h3>{item.plan?.name}</h3>
                            <span className="mt-2  text-justify leading-6">مبلغ پرداخت شده : {CommaFire(item.plan?.amount)} تومان</span>
                        </div>
                        <div onClick={() => openFactor(item)} className="w-[100px] h-[40px] border sm:mt-0 mt-3 flex items-center justify-center text-[11px] text-white rounded-lg bg-dayan-gray-200 cursor-pointer">دانلود فاکتور</div>
                    </div>
                )}
            </div>

            <div className=" w-full mt-[20px]">
                <TablePagination currentPage={currentPage} lastPage={lastPage} onChange={changePage} />
            </div>

            <CModal visible={visible} setVisible={setVisible} radius={'10px'} uId="Mo-history" width="700px" >
                <>
                    {selectedFile != null &&
                        <div className=" w-full flex flex-col">
                            <div ref={ref} className="w-full  flex flex-col bg-white">
                                <div className="w-full flex items-center justify-between px-2 my-7">
                                    <div className="flex items-center">
                                        <span>وضعیت نهایی :</span>
                                        <span></span>
                                    </div>
                                    <div className="flex items-center">
                                        <span>تاریخ :</span>
                                        <span>{new Date(selectedFile.updated_at).toLocaleDateString('fa-Ir')}</span>
                                    </div>
                                </div>
                                <div className="flex w-full border border-gray-700">
                                    <div className="w-full h-[50px] border-l border-gray-700 flex justify-center items-center bg-blue-200"> نام محصول</div>
                                    <div className="w-full h-[50px] border-l border-gray-700 flex justify-center items-center bg-blue-200"> تعداد</div>
                                    <div className="w-full h-[50px] border-l border-gray-700 flex justify-center items-center bg-blue-200"> قیمت واحد</div>
                                    <div className="w-full h-[50px] border-gray-700 flex justify-center items-center bg-blue-200"> مجموع</div>
                                </div>
                                <div className="flex w-full border border-gray-700">
                                    <div className="w-full h-[50px] border-l border-gray-700 flex justify-center items-center ">پلن {selectedFile.plan?.name}</div>
                                    <div className="w-full h-[50px] border-l border-gray-700 flex justify-center items-center "> {selectedFile.plan?.duration}</div>
                                    <div className="w-full h-[50px] border-l border-gray-700 flex justify-center items-center "> {CommaFire(+selectedFile.plan?.amount)} تومان</div>
                                    <div className="w-full h-[50px] border-gray-700 flex justify-center items-center ">{CommaFire(+selectedFile.plan?.amount * +selectedFile.plan?.duration)} تومان </div>
                                </div>
                                <div className="w-full flex items-center justify-between px-2 my-7">
                                    <div className="flex flex-col">
                                        <span>کد تخفیف استفاده شده :</span>
                                        <span></span>
                                    </div>
                                    <div className="flex flex-col">
                                        <span>مقدار تخفیف :</span>
                                        <span>{selectedFile.discount_amount != null && `${CommaFire(+selectedFile.discount_amount)} تومان`} </span>
                                    </div>
                                    <div className="flex flex-col">
                                        <span>پرداخت نهایی :</span>
                                        <span className="text-base mt-1">{CommaFire(+selectedFile.plan?.amount * +selectedFile.plan?.duration)} تومان</span>
                                    </div>
                                </div>
                            </div>
                            <div className="flex mt-[40px]">
                                <button type={'button'} onClick={() => { setVisible(false) }} className="w-[100px] mx-2 h-10 bg-dayan-gray-200  flex items-center justify-center rounded-[5px] text-white">
                                    <span>بستن</span>
                                </button>
                                <button type={'button'} onClick={exportFactor} className=" w-[100px] mx-2 h-10 bg-dayan-orange-50  flex items-center justify-center rounded-[5px] text-white">
                                    <span>دانلود فاکتور</span>
                                </button>
                            </div>
                        </div>
                    }
                </>
            </CModal>

        </div>
    )
}
